export default "/images/capcha.png?dcfe365ae53de5ef2b846c1320168a7e";